// src/utils/documentSettings.js — doced-8f3a61c2 (Document editor, Stage 5d: Settings › Documents)
//
// The company's default customer-facing Terms, kept on the company record:
//
//   organizations/{org}.documentTerms = { estimate: '<text>' }      (invoice: later, with the new invoice page)
//
// Written by Settings › Documents (Owner / Admin / Manager — firestore.rules isHighLevel; the field is not
// server-owned) with a dotted-path update, so nothing else on the company record is touched. Read when a NEW
// estimate is created on the estimate page (Stage 5e pre-fill): an estimate keeps the terms it was made with,
// so changing the default never changes an estimate that already exists. The PDF and the portal print the
// estimate's OWN terms (quote.terms), never this default.
//
// Pure: no Firebase, so the screen and the 5e pre-fill share one reading of the field.

export const DOCUMENT_TERMS_FIELD = 'documentTerms';
export const ESTIMATE_TERMS_PATH = 'documentTerms.estimate';
export const TERMS_MAX = 10000;

/** The company's default estimate terms ('' when none, or when the stored value isn't text). */
export function estimateTermsFromCompany(company) {
    const map = company && company[DOCUMENT_TERMS_FIELD];
    if (!map || typeof map !== 'object' || Array.isArray(map)) return '';
    return typeof map.estimate === 'string' ? map.estimate : '';
}

/** What Save stores: line endings made consistent, blank lines at the very start and end removed. */
export function cleanTerms(text) {
    return String(text == null ? '' : text).replace(/\r\n?/g, '\n').trim();
}

/** Does the box differ from what is saved? (Spaces at the very ends don't count.) */
export function termsChanged(saved, draft) {
    return cleanTerms(saved) !== cleanTerms(draft);
}

/** The problem with the box, in plain words, or null. */
export function termsProblem(draft) {
    const n = cleanTerms(draft).length;
    if (n > TERMS_MAX) return `Terms can be at most ${TERMS_MAX.toLocaleString('en-US')} characters (this is ${n.toLocaleString('en-US')}).`;
    return null;
}
